import { render, staticRenderFns } from "./IconNoon.vue?vue&type=template&id=1c0f5a24&"
import script from "./IconNoon.vue?vue&type=script&lang=js&"
export * from "./IconNoon.vue?vue&type=script&lang=js&"
import style0 from "./IconNoon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports